import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "hint"]

  toggle() {
    this.active = !this.active

    this.hintTargets.forEach((hint) => {
      hint.classList.toggle("hidden", !this.active)
    })

    this.toggleTarget.classList.toggle("ring-indigo-500", this.active)
    this.toggleTarget.classList.toggle("bg-indigo-50", this.active)
    this.toggleTarget.classList.toggle("text-indigo-700", this.active)
    this.toggleTarget.classList.toggle("ring-gray-300", !this.active)
    this.toggleTarget.classList.toggle("text-gray-700", !this.active)
  }

  connect() {
    this.active = false
  }
}
